<template>
    <StepContainer>
        <div v-show="!showXDLogin">
            <div class="name">请选择账号类型：</div>
            <ul class="account-list">
                <li v-for="way in gameInfo.login_ways" :key="way">
                    <div class="login-btn" @click="login(way)">
                        <a :href="way != 'xd' ? `/api/v1/verify?choose_app=${game}&oauth_type=${way}` : 'javascript:;'" :class="`${way} xdicon xdicon-${way}`"></a>
                    </div>
                </li>
            </ul>
        </div>
        <div v-show="showXDLogin">
            <div class="back" @click="showXDLogin = false">返回上一级</div>
            <div class="login-box">
                <div class="title">心动账号：</div>
                <div class="input-box">
                    <input type="text" v-model="userName"  placeholder="用户名">
                    <Prompt class="prompt" :options="userPrompt"/>
                </div>
                
                <div class="input-box">
                    <input type="password" v-model="password" placeholder="密码">
                    <Prompt class="prompt" :options="passwordPrompt"/>
                </div>
                <button class="btn-primary loginBtn">
                    登陆
                    <div id="geetest-captcha"></div>
                </button>
            </div>
        </div>
    </StepContainer>
</template>

<script>
import StepContainer from '@/views/step-container';
import store from '@/store';
import * as api from '@/api/index';
import '@/libs/gt.js';
import Prompt from '@/components/prompt';

export default {
    components: {
        StepContainer,
        Prompt
    },
    data () {
        return {
            account: {},
            gameInfo: {},
            game: '',
            sharedState: store.state,
            showXDLogin: false,

            captchaObj: '',
            random: 0,
            userName: '',
            password: '',

            userPrompt: {
                type: '',
                msg: ''
            },
            passwordPrompt: {
                type: '',
                msg: ''
            }
        }
    },
    watch: {
        sharedState: {
            handler: function(newVal) {
                if(newVal.gameList) {
                    this.game = this.$route.query.app;
                    newVal.gameList.map(item => {
                        if(this.game == item.app) {
                            this.gameInfo = item
                        }
                    })
                }
            },
            immediate: true,
            deep: true
        },
        showXDLogin (newVal) {
            if(newVal && this.captchaObj) {
                this.captchaObj.reset()
                this.userName = ''
                this.password = ''
                this.userPrompt = {
                    type: '',
                    msg: ''
                }
                this.passwordPrompt = {
                    type: '',
                    msg: ''
                }
            }
        },
        userName (newVal) {
            if(newVal) {
                this.userPrompt = {
                    type: '',
                    msg: ''
                }
            }
        },
        password (newVal) {
            if(newVal) {
                this.passwordPrompt = {
                    type: '',
                    msg: ''
                }
            }
        }
    },
    mounted () {
        this.createGeetest()
    },
    methods: {
        getUrl(way) {
            if(way != 'xd' && way != 'verycd') {
                return `https://www.xd.com/${way}?game=${this.game}`
            }else {
                return 'javascript:;'
            }
        },
        createGeetest() {
            this.random = Math.random()
            let initData = {
                auth_key: this.random
            };
            api.api_geetest(initData).then(result => {
                if (result.status == 200 && result.data.success) {
                    let data = result.data
                    //请检测data的数据结构， 保证data.gt, data.challenge, data.success有值
                    initGeetest(
                        {
                            // 以下配置参数来自服务端 SDK
                            gt: data.gt,
                            challenge: data.challenge,
                            offline: !data.success,
                            new_captcha: true,
                            product: 'float',
                        },
                        (captchaObj) => {
                            this.captchaObj = captchaObj
                            // 这里可以调用验证实例 captchaObj 的实例方法
                            captchaObj.appendTo('#geetest-captcha'); //将验证按钮插入到宿主页面中captchaBox元素内
                            captchaObj.onSuccess(() => {
                                if(!this.userName) {
                                    this.userPrompt = {
                                        type: 'error',
                                        msg: '请填写用户名'
                                    }
                                }
                                if(!this.password) {
                                    this.passwordPrompt = {
                                        type: 'error',
                                        msg: '请填写密码'
                                    }
                                }
                                let result = captchaObj.getValidate();
                                if (this.userName && this.password && result) {
                                    let data = {
                                        choose_app: this.game,
                                        oauth_type: 'xd',
                                        user_name: this.userName,
                                        password: this.password,
                                        auth_key: this.random,
                                        geetest_challenge: result.geetest_challenge,
                                        geetest_validate: result.geetest_validate,
                                        geetest_seccode: result.geetest_seccode
                                    }
                                    api.loginVerify(data).then(result => {
                                        if(result.status == 200) {
                                            this.$router.push({path: '/step3', query: {app: this.game, way: 'xd', token: result.data.token}})
                                        }else {
                                            alert(result.data)
                                        }

                                        captchaObj.reset()
                                    })
                                }
                            });
                        }
                    );
                }else {
                    alert(result.data)
                }
            });
        },
        login (way) {
            if(way == 'xd') {
                this.showXDLogin = true
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .account-list {
        display: flex;
        justify-content: center;
        margin: 100px 0 200px;
        li {
            margin: 0 30px;
            .login-btn {
                a {
                    display: inline-block;
                    width: 50px;
                    height: 50px;
                    line-height: 50px;
                    border-radius: 5px;
                    font-size: 34px;
                    &.weixin {
                        background-color: #00bb00;
                        &:before {
                            color: #fff;
                        }
                    }
                    &.qq {
                        background-color: #2a9cd5;
                        font-size: 25px;
                        &:before {
                            color: #fff;
                        }
                    }
                    &.taptap {
                        background-color: #14b9c8;
                        &:before {
                            color: #fff;
                        }
                    }
                    &.xd {
                        background-color: #ff6600;
                        &:before {
                            color: #fff;
                        }
                    }
                    &.apple {
                        background-color: #0a0a0a;
                        background-image: url('https://www.xd.com/imgs/v4/service/transfer_gold/apple-icon@2x.png?1614827907');
                        background-size: 28px;
                        background-repeat: no-repeat;
                        background-position: center;
                    }
                }
            }
        }
    }
    .back {
        color: $reward;
        cursor: pointer;
    }
    .login-box {
        width: 290px;
        margin: 20px auto;
        .title {
            margin-bottom: 15px;
            font-size: 16px;
        }
        input {
            width: 280px;
            height: 38px;
            line-height: 38px;
            padding-left: 10px;
            border: 1px solid #e6e6e6;
            border-radius: 5px;
        }
        .input-box {
            position: relative;
            margin-bottom: 23px;
            .prompt {
                position: absolute;
                bottom: -18px;
                font-size: 12px;
            }
        }

        .loginBtn {
            width: 294px;
            height: 42px;
            line-height: 42px;
            border-radius: 21px;
            position: relative;
            overflow: hidden;
            transition: all ease-in-out 200ms;
            cursor: pointer;
            #geetest-captcha {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                opacity: 0;
            }
        }
    }
</style>